import { withTranslations } from 'src/i18n/static-generation';
import LicenseView from 'src/views/License';
export const getStaticProps = withTranslations(() => ({
  props: {}
}));
export default LicenseView;